import MoreOfferManager from '../../../bussinessComponent/MoreOfferManager'
import SingleOfferTemplate from "../../../component/template/SingleOfferTemplate"
import App from "../../../App"
import { getPageUrlParams, getTemplateName } from '../../../../common/util'
import { reportNonBizData } from "../../../../common/m_common/mNonBizReport"
import { reportUrlList } from '../../../../common/m_common/mBizReport'
import Message from "../../../FrameMessage";


export default class Endcard extends SingleOfferTemplate {
  constructor(...props) {
    super(...props)
    this.name = 'Endcard'
    this.clsdly = getPageUrlParams('clsdly') || App.initData.unitSetting.close_button_delay
    this.mofEnable = getPageUrlParams('mof')
    this.mofAbtest = getPageUrlParams('mof_ab')
    this.tplName = getTemplateName()
    this.autoClick = getPageUrlParams('alac')
    this.allowFullScreenClick = getUrlParams('alecfc')
    this.enlargeCloseBtnZone = getUrlParams('ctnsize') == 2 ? true : false
  }

  adShowed() {
    super.adShowed()

    // 延时显示关闭按钮
    const closeBtn = document.querySelector('.mtg-btn-close-white')
    if (this.clsdly > 0) {
      setTimeout(() => closeBtn.style.visibility = 'visible', this.clsdly * 1000)
    } else if (this.clsdly != -1 && this.clsdly != 0) {
      setTimeout(() => closeBtn.style.visibility = 'visible', 2000)
    }

    // storekit自动点击
    if (this.autoClick == 1 && this.campaign.like_type == 1) {
      setTimeout(() => {
        console.log('storekit自动点击被触发')
        const sendData = {
          instanceId: App.rootWebviewId,
          campaign: this.campaign,
          type: 'auto',
        }
        Message.emitMessageToSuperView('onInstallBtnClick', sendData)
      }, 300)
    }

    // 延时1s展示猜你喜欢
    setTimeout(() => {
      this.moreOffer.appendTo() && reportUrlList([this.moreOffer.getOnlyImpression()])
    }, 1000)

    this.reportSelfMonitor('MTG_EC_show')
  }

  initComponents() {
    super.initComponents()

    // 初始化猜你喜欢组件，并在render后append到.container上
    if (this.mofEnable == 1 && this.mofAbtest != 1) {
      this.moreOffer = new MoreOfferManager({
        campaign: this.campaign,
        onLoadSuccess: [],
        onLoadFailed: [],
        onScroll: [],
        onReady: [],
        onError: [],
        onOfferClick: [],
      })
      this.moreOffer.render()
    }

    // 需要延时出关闭按钮时初始化隐藏关闭按钮
    const closeBtn = document.querySelector('.mtg-btn-close-white')
    if (this.clsdly != 0) {
      closeBtn.style.visibility = 'hidden'
    }

    // 根据配置扩大关闭按钮区域
    if (this.enlargeCloseBtnZone) {
      document.querySelector('#close-area').classList.add('close-area-big')
    }
  }

  bindPageEvent() {
    super.bindPageEvent()

    // 绑定关闭按钮事件
    const closeBtn = document.querySelector('.mtg-btn-close-white')
    if (closeBtn) {
      closeBtn.addEventListener('click', () => {
        console.log('关闭按钮被点击-')
        this.reportSelfMonitor('MTG_EC_close')
        Message.emitMessageToSuperView('MTG_TriggerCloseBtn')
      }, false)
    }

    setTimeout(()=>{
      Message.emitMessageToSuperView('MTG_EndcardHasReady')
    },0)

    // 根据模板确定可点击区域
    const imageBox = document.querySelector('.image-box')
    const iconBox = document.querySelector('.icon-box')
    const installBox = document.querySelector('.install-box')
    const clickEventTarget = []
    if (this.allowFullScreenClick) {
      // 全屏可点时只在最外层div绑定点击事件
      clickEventTarget.push(document.querySelector('#container'))
    } else {
      clickEventTarget.push(installBox)
      if (this.tplName == '3like.v4') {
        clickEventTarget.push(imageBox, iconBox)
      }
    }
    clickEventTarget.forEach((el) => {
      this.bindClickInstallEvent(el)
    })
  }

  bindClickInstallEvent(el) {
    el.addEventListener('click', () => {
      console.log('安装被触发')
      this.reportSelfMonitor('MTG_EC_click')
      const sendData = {
        instanceId: App.rootWebviewId,
        campaign: this.campaign,
      }
      Message.emitMessageToSuperView('onInstallBtnClick', sendData)
    }, false)
  }

  reportSelfMonitor(reportType) {
    return reportNonBizData({
      reportType
    })
  }

  _isLoadFinish() {
    const promise = Promise.all([
      super._isLoadFinish(),
      this.reportSelfMonitor('MTG_EC_render')
    ])
    return promise
  }
}